import { render, staticRenderFns } from "./WhatsappGroupEdit.vue?vue&type=template&id=17f40058"
import script from "./WhatsappGroupEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./WhatsappGroupEdit.vue?vue&type=style&index=0&id=17f40058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports